import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  padding-inline: ${themeGet('space.3')}px ${themeGet('space.5')}px;
  gap: ${themeGet('space.5')}px;
  background-color: ${themeGet('colors.surface.subtle')};
  border-radius: 16px;

  img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 12px;
  }
`
